(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-tabs"] && !Shopify.designMode) return;
  try {
    
function initCollectionSwipers() {
  const swipers = [];
  const swiperContainers = document.querySelectorAll('.tabs-carousel__swiper');

  swiperContainers.forEach((container) => {
    const swiper = new Swiper(container, {
      slidesPerView: 5,
      spaceBetween: 16,
      watchOverflow: false,
      navigation: {
        nextEl: container.querySelector('.swiper-button-next'),
        prevEl: container.querySelector('.swiper-button-prev')
      },
      breakpoints: {
        320: {
          slidesPerView: 1.3,
          spaceBetween: 5
        },
        768: {
          slidesPerView: 1.2,
          spaceBetween: 5
        },
        1024: { slidesPerView: 5 }
      }
    });
    swipers.push(swiper);
  });

  const tabs = document.querySelectorAll('.tabs-carousel__nav-item');
  const tabContents = document.querySelectorAll('.tabs-carousel__content');

  if (tabs.length) {
    tabs[0].classList.add('active');
    tabContents[0].classList.add('active');
  }

  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => {
      tabs.forEach(t => t.classList.remove('active'));
      tabContents.forEach(c => c.classList.remove('active'));

      tab.classList.add('active');
      const activeContent = document.getElementById(tab.dataset.tab);
      activeContent.classList.add('active');

      const swiper = swipers[index];
      swiper.update();
      swiper.slideTo(0);

      const prevBtn = activeContent.querySelector('.swiper-button-prev');
      const nextBtn = activeContent.querySelector('.swiper-button-next');
      [prevBtn, nextBtn].forEach(btn => {
        if (btn) {
          btn.removeAttribute('aria-disabled');
          btn.classList.remove('swiper-button-disabled');
        }
      });
    });
  });
}

document.addEventListener('DOMContentLoaded', initCollectionSwipers);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
